import React from 'react';
import { Switch } from 'react-router-dom';
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import DispatcherDashboard from 'app/entities/dispatcher-dashboard/dispatcher-dashboard';
import DispatcherDashboardJourney from 'app/entities/dispatcher-dashboard/dispatcher-dashboard-journey';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute path={`${match.url}`} exact component={DispatcherDashboard} />
      <ErrorBoundaryRoute path={`${match.url}/journey`} component={DispatcherDashboardJourney} />
    </Switch>
  </>
);

export default Routes;
